/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronicline.com | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
$(function () {
  $.each(window.DeskWhyUs, function (sectionId) {
    var section = document.getElementById('shopify-section-' + sectionId);
    if (!section) return;

    var swiperInstance = null;

    function initSwiper() {
      if (window.innerWidth < 799) {
        if (swiperInstance) return;
        swiperInstance = new Swiper(section.querySelector('.why-us__swiper'), {
          slidesPerView: 1.2,
          spaceBetween: 16,
          centeredSlides: false,
          pagination: {
            el: section.querySelector('.why-us__pagination'),
            clickable: true
          },
          navigation: {
            nextEl: section.querySelector('.why-us__next'),
            prevEl: section.querySelector('.why-us__prev')
          }
        });
      } else {
        if (swiperInstance) {
          swiperInstance.destroy(true, true);
          swiperInstance = null;
        }
      }
    }

    initSwiper();
    $(window).on('resize', initSwiper);

    // Video observer
    var videos = section.querySelectorAll('.why-us__video[data-src]');
    if (videos.length) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            if (!video.src) video.src = video.dataset.src;
            video.play();
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.3 });

      videos.forEach(function (video) {
        observer.observe(video);
      });
    }

    // Scroll reveal
    var srElements = section.querySelectorAll('.sr-hidden');
    if (srElements.length) {
      if (window.innerWidth > 799 && typeof ScrollReveal !== 'undefined') {
        srElements.forEach(function (el, i) {
          ScrollReveal().reveal(el, {
            origin: 'bottom',
            distance: '20px',
            duration: 700,
            delay: 0 + (i * 40),
            easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
            opacity: 0,
            scale: 1,
            once: true
          });
        });
      } else {
        srElements.forEach(function (el) {
          if (typeof ScrollReveal !== 'undefined') ScrollReveal().clean(el);
          el.style.visibility = 'visible';
          el.style.opacity = 1;
        });
      }
    }
  });
});